import type { ServiceLevelIdicatorWithHistory, ServiceStatusParams } from './types';
import GatewayAxiosClient from '../GatewayAxiosClient';

export class ApiStatusService {
  public async fetchApiStatus(params: ServiceStatusParams): Promise<ServiceLevelIdicatorWithHistory[]> {
    // using the mock in all envs until real implementaion
    const res = await GatewayAxiosClient.get('/api-status');
    return res.data;
  }
}
